export default {
  title: "Explore Kozmap".toUpperCase(),
}
